import { useState } from "react"
import { useApi } from "utils"
import {
  LiquidityKey,
  LiquiditySuccessFetch
} from "../../types/liquidityTableType"

export const liquidityApis = [
  {
    category: "LIQUIDITY RATIOS",
    code_budget: "CR",
    key_description: "Current Ratio",
    url: "analytic/current_ratio/yearly"
  },
  {
    category: "LIQUIDITY RATIOS",
    code_budget: "QCR",
    key_description: "Quick Current Ratio",
    url: "analytic/quick_current_ratio/yearly"
  },
  {
    category: "LEVERAGE RATIOS",
    code_budget: "DTER",
    key_description: "Debt To Equity Ratio",
    url: "analytic/debt_to_equity_ratio/yearly"
  },
  {
    category: "LEVERAGE RATIOS",
    code_budget: "FL",
    key_description: "Financial Leverage",
    url: "analytic/financial_leverage/yearly"
  },
  {
    category: "LEVERAGE RATIOS",
    code_budget: "TL",
    key_description: "Total Leverage",
    url: "analytic/total_leverage/yearly"
  },
  {
    category: "PROFITABILITY",
    code_budget: "GMP",
    key_description: "Gross Margin Percentage",
    url: "analytic/gross_margin_percentage/yearly"
  },
  {
    category: "PROFITABILITY",
    code_budget: "NOMP",
    key_description: "Net Operating Margin Percentage",
    url: "analytic/net_operating_margin_percentage/yearly"
  },
  {
    category: "PROFITABILITY",
    code_budget: "NPM",
    key_description: "Net Profit Margin",
    url: "analytic/net_profit_margin/yearly"
  },
  {
    category: "EFFICIENCY RATIOS",
    code_budget: "ROA",
    key_description: "Return On Assets",
    url: "analytic/return_of_asset/yearly"
  },
  {
    category: "EFFICIENCY RATIOS",
    code_budget: "ITR",
    key_description: "Inventory Turnover Ratio",
    url: "analytic/inventory_turnover_ratio/yearly"
  },
  {
    category: "INVESTMENT RATIOS",
    code_budget: "ROE",
    key_description: "Return On Equity",
    url: "analytic/return_on_equity/yearly"
  },
  {
    category: "INVESTMENT RATIOS",
    code_budget: "OP",
    key_description: "Operating Ratio",
    url: "/analytic/operating_ratio/yearly"
  },
  {
    category: "INVESTMENT RATIOS",
    code_budget: "OL",
    key_description: "Operating Leverage",
    url: "/analytic/operating_leverage_ratio/yearly"
  }
]

export function useLiquidityRatio(
  year?: number,
  location_id?: string | ""
) {
  const api = useApi()

  const [data, setData] = useState<LiquidityKey[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchData = async () => {
    if (!year) return

    setLoading(true)
    setError(null)

    try {
      const params: any = { year }

      if (location_id && location_id !== "") {
        params.location_id = location_id
      }

      const responses = await Promise.all(
        liquidityApis.map(async (item) => {
          try {
            const res = await api.get(item.url, { params })

            const response: LiquiditySuccessFetch = res.data
            const payload = response.payload?.[0]

            return {
              ...payload,
              category: item.category,
              key_description: item.key_description,
              code_budget: item.code_budget
            }
          } catch {
            // kalau API salah satu gagal tetap return row kosong
            return {
              key_description: item.key_description,
              code_budget: item.code_budget,
              budget: "",
              average: "",
              january: null,
              february: null,
              march: null,
              april: null,
              may: null,
              june: null,
              july: null,
              august: null,
              september: null,
              october: null,
              november: null,
              december: null
            }
          }
        })
      )

      setData(responses)

    } catch (err: any) {
      setError(err?.response?.data?.message || "Failed to fetch data")
      setData([])
    } finally {
      setLoading(false)
    }
  }

  const refetchLiquidity = () => fetchData()

  return {
    liquidityData: data,
    loading,
    error,
    refetchLiquidity
  }
}